import * as React from 'react';

export function SvgAlignBottom(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20a1 1 0 011-1h12.444a1 1 0 110 2H6a1 1 0 01-1-1zM7.07 9.515a1 1 0 011.415 0l3.737 3.737 3.738-3.737a1 1 0 111.414 1.414l-4.445 4.445a1 1 0 01-1.414 0l-4.444-4.445a1 1 0 010-1.414z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.222 3a1 1 0 011 1v10.667a1 1 0 11-2 0V4a1 1 0 011-1z"
        fill="currentColor"
      />
    </svg>
  );
}
